import React from 'react';
import { StarIcon, UserIcon } from 'lucide-react';
import { testimonials } from '../data/content';
export function TestimonialsSection() {
  return <section className="w-full bg-white px-4 py-12 sm:px-5 sm:py-16" data-id="element-182" data-mp="20qnqrydhaxst">
      <div className="mx-auto max-w-[1040px]" data-id="element-183" data-mp="1mz93hfcjgafy">
        <h2 className="text-balance text-center text-[clamp(1.6rem,4.5vw,2.8rem)] font-black uppercase leading-none tracking-tight text-slate-950" data-id="element-184" data-mp="1r1m8u2ndi6c7">
          What Anatomy & Physiology teachers{' '}
          <span className="text-orange-700" data-id="element-185" data-mp="1i0xu15q5o1y9">are saying</span>
        </h2>

        <ul className="mt-8 grid gap-4 md:grid-cols-2" data-id="element-186" data-mp="1i28zd9z91hrh">
          {testimonials.map((testimonial, index) => {
          const isFeatured = index === 0;
          const initial = /^[A-Za-z]/.test(testimonial.name) ? testimonial.name[0] : null;
          return <li key={`${testimonial.quote}-${index}`} className={`flex flex-col rounded-xl border border-slate-200 bg-white p-5 shadow-sm sm:p-7 ${isFeatured ? 'border-l-[5px] border-l-orange-500 md:col-span-2' : ''}`} data-id="element-187" data-mp="2yfz14a2wbtxy" data-mpi={index}>
                <div className="flex gap-1" role="img" aria-label="Rated 5 out of 5 stars" data-id="element-188" data-mp="2q0eyao5voil6">
                  {Array.from({
                length: 5
              }).map((_, starIndex) => <StarIcon key={starIndex} className="h-5 w-5 fill-orange-500 text-orange-500" aria-hidden="true" data-id="element-189" data-mp="2c2gnttuoh6ay" data-mpi={starIndex} />)}
                </div>

                <blockquote className="mt-3 text-[1.02rem] leading-relaxed text-slate-700 sm:text-[1.08rem]" data-id="element-190" data-mp="2m2h75fsjrmf5">
                  “{testimonial.quote}”
                </blockquote>

                <div className="mt-auto flex items-center gap-3 pt-5" data-id="element-191" data-mp="19m6bweiheuy">
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-slate-950 text-[1.05rem] font-black text-white" aria-hidden="true" data-id="element-192" data-mp="3shhtquvoms92">
                    {initial ?? <UserIcon className="h-5 w-5 text-orange-500" data-id="element-193" data-mp="8cajiz1166j9" />}
                  </span>
                  <div className="min-w-0" data-id="element-194" data-mp="de9js01h4nbz">
                    <p className="text-[1.05rem] font-black uppercase leading-tight tracking-tight text-slate-950" data-id="element-195" data-mp="ic1c2v616bgp">
                      {testimonial.name}
                    </p>
                    <p className="text-[0.85rem] font-semibold leading-snug text-slate-600" data-id="element-196" data-mp="3grki3x5potma">
                      {testimonial.role} · {testimonial.location}
                    </p>
                  </div>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}